import React from 'react';

import { CmBox, CmFlex } from '@/components/uiParts';

export const CONTENT_INNER_PX_SIZE = 28;
export const PAGE_CONTAINER_ID = 'page-container';

export const PageContainer: React.FC = ({ children }) => {
  return (
    <CmFlex
      id={PAGE_CONTAINER_ID}
      direction="column"
      align="center"
      px={`${CONTENT_INNER_PX_SIZE}px`}
    >
      <CmBox width={{ base: '100%' }}>{children}</CmBox>
    </CmFlex>
  );
};
